import { render, staticRenderFns } from "./import-category.vue?vue&type=template&id=71e16c18&"
import script from "./import-category.vue?vue&type=script&lang=ts&"
export * from "./import-category.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports